import { render, staticRenderFns } from "./Sequence.vue?vue&type=template&id=ff7ffe42&scoped=true"
import script from "./Sequence.vue?vue&type=script&lang=js"
export * from "./Sequence.vue?vue&type=script&lang=js"
import style0 from "./Sequence.vue?vue&type=style&index=0&id=ff7ffe42&prod&lang=less&scoped=true"
import style1 from "./Sequence.vue?vue&type=style&index=1&id=ff7ffe42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7ffe42",
  null
  
)

export default component.exports